module.exports = __webpack_public_path__ + "img/Dantam Hair 35.80dcd3bb.jpg";